module.exports = __webpack_public_path__ + "img/goods-6.1e5fd5c3.png";